"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderDropdownButton = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../../context");

var _button = require("../../button");

var _constants = require("../../button/constants");

var _utils = require("../../utils");

var _ = require("./");

var _core = require("@emotion/core");

var PageHeaderDropdownButtonBase = (0, _context.styledWithTheme)(_button.Button)(function (_ref) {
  var theme = _ref.theme;
  return "\n  background-color: transparent;\n  border-radius: 0;\n  padding: 16px 24px;\n  height: 100%;\n  width: 100%;\n  font-weight: ".concat(theme.selectors.fontWeight('regular'), ";\n  justify-content: flex-start;\n\n  :hover {\n    background-color: ").concat(theme.selectors.color('primary05'), ";\n    text-decoration: none;\n  }\n\n  :before {\n    top: -").concat(_constants.BORDER_WIDTH, "px;\n    bottom: -").concat(_constants.BORDER_WIDTH, "px;\n    left: -").concat(_constants.BORDER_WIDTH, "px;\n    right: -").concat(_constants.BORDER_WIDTH, "px;\n    border-radius: 0;\n  }\n\n  &:focus,\n  &:visited,\n  &:active {\n    outline-offset: -2px;\n  }\n");
});
var PageHeaderDropdownButtonWithoutDocs = (0, _react.forwardRef)(function (_ref2, ref) {
  var dataTestId = _ref2.dataTestId,
      children = _ref2.children,
      buttonProps = (0, _objectWithoutProperties2.default)(_ref2, ["dataTestId", "children"]);
  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilReactPageHeaderDropdownButton',
    dataTestId: dataTestId
  });
  return (0, _core.jsx)(PageHeaderDropdownButtonBase, (0, _extends2.default)({
    shouldUseResponsiveContent: false,
    variant: _button.ButtonVariant.Tertiary
  }, dataTestProps, buttonProps, {
    ref: ref
  }), children);
});
var PageHeaderDropdownButton = (0, _stencilReactDesc.describe)(PageHeaderDropdownButtonWithoutDocs).description('Button dropdown item for PageHeader.');
exports.PageHeaderDropdownButton = PageHeaderDropdownButton;
PageHeaderDropdownButton.displayName = 'PageHeaderDropdownButton';
PageHeaderDropdownButton.propTypes = (0, _objectSpread2.default)({}, _button.Button.describedPropTypes, (0, _utils.pick)(_.PageHeaderButton.describedPropTypes, ['dataTestId', 'children', 'icon']));